var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.referenceName,staticClass:"smart-captcha",attrs:{"id":"captcha-container","data-sitekey":_vm.apiToken}})}
var staticRenderFns = []

export { render, staticRenderFns }